<script>
  /* eslint-disable import/no-mutable-exports */
  import formatMoney from "../../utils/currency.js";
  import YotpoReviewStars from "./YotpoReviewStars.svelte";

  function formatLabel() {
    const discount = Math.floor(100 * (product.compareAtPrice - product.price) / product.compareAtPrice);
    return `SALE -${discount}%`;
  }

  /** {Product} product */
  export let product;
  /*** {Boolean} swiperSlide */
  export let swiperSlide = false;
  /** {Array} doNotRender */
  export const doNotRender = [];
</script>

<a href="{product.url}" class="{swiperSlide ? 'swiper-slide' : ''} h-full flex flex-col justify-between relative" tabindex="-1">
  <div>
    <div class="w-full relative bg-product-image-blend group" data-image-container>
      <div class="block aspect-w-1 aspect-h-1 relative h-full">
        <img
          src="{product.sizedProgressiveImage(384)}"
          alt="{product.title}"
          class="object-contain mix-blend-multiply w-full h-full"
          loading="lazy"
        >
      </div>
    </div>

    <div class="mt-5">
      <YotpoReviewStars {product} />
    </div>

    <div class="flex flex-col justify-center items-center text-brand-blue">
      <p class="b2 text-center px-1">
        {product.title}
      </p>
    </div>
  </div>

  <div class="flex flex-col justify-center items-center text-brand-blue mb-0.5">
    <span class="b2 flex space-x-1 justify-center text-center stretch-expanded mt-s">
      {#if product.compareAtPrice > product.price}
        <p class="line-through">
          {formatMoney(product.compareAtPrice)}
        </p>
      {/if}

      <p class="font-bold">{formatMoney(product.price)}</p>
    </span>

    {#if product.compareAtPrice > product.price}
      <div class="z-10 mt-s font-semibold lg:mt-0 lg:absolute lg:right-0 lg:top-0">
        <p
          class="
            b3
            lg:b2
            stretch-semi-expanded
            w-fit
            h-fit
            bg-brand-yellow
            text-brand-blue
            px-xxs-mobile
            lg:px-xxs
            py-[1.5px]
          "
        >
          {formatLabel()}
        </p>
      </div>
    {:else}
      <div class="z-10 mt-s lg:mt-0 lg:absolute lg:right-0 lg:top-0 h-[20.28px]"></div>
    {/if}

    <p class="btn btn--outline btn--blue btn--small xs:btn--medium xl:btn--large mt-l-mobile" tabindex="0">View Product</p>
  </div>
</a>
